import { tWithKeyAttr as t } from "../../i18nHelper";
import notFoundStyles from "./notFound.module.css";
import notFoundPic from "../../images/notFound.png";

function NotFoundPage() {
  return (
    <section className={notFoundStyles.section}>
      <h2 className={notFoundStyles.title}>{t('WE_ARE_HERE_FOR_YOU')}</h2>
      <p className={`${notFoundStyles.text} ${notFoundStyles.text_small}`}>
        {t('OOPS_IT_SEEMS_YOU_STRAYED')}</p>
      <p className={notFoundStyles.text}>
        {t('FEELING_OF_NOT_KNOWING')}</p>
      <p className={notFoundStyles.text}>{t('BUT_YOU_ARE_NOT_ALONE')}</p>
      <p className={notFoundStyles.text}>
        {t('SUPPORTING_YOUR_WELLBEING')}</p>
      <img
        src={notFoundPic}
        alt={t('NUMBER_404_IN_SPACE')}
        className={notFoundStyles.img}
      />
      {/*<Link to={"/users"} className={`button hover ${notFoundStyles.link}`}>*/}
      {/*  חזרה לדף הבית*/}
      {/*</Link>*/}
      {/*<p className={notFoundStyles.text}>*/}
      {/*  אם נדרשת לך עזרה מיידית, אל תהסס לפנות*/}
      {/*</p>*/}
      {/*<article className={notFoundStyles.footer}>*/}
      {/*  <h4 className={notFoundStyles.footerTitle}>שעות פעילות</h4>*/}
      {/*  <p className={notFoundStyles.footerText}>*/}
      {/*    א’ - ה’ בין השעות 16:00 - 09.00*/}
      {/*  </p>*/}
      {/*  <p className={notFoundStyles.footerText}>*/}
      {/*    יום ו’ בין השעות 13:00 - 09:00*/}
      {/*  </p>*/}
      {/*  <p className={notFoundStyles.footerText}>*/}
      {/*    פניות שיפתחו בשעות הפעילות יקבלו מענה עד סוף היום*/}
      {/*  </p>*/}
      {/*  <p className={notFoundStyles.footerText}>*/}
      {/*    פניות שיפתחו לאחר שעות הפעילות, יענו עד סוף היום הבא*/}
      {/*  </p>*/}
      {/*  <p className={notFoundStyles.footerText}>*/}
      {/*    במקרים דחופים חייגו : 075-5913596*/}
      {/*  </p>*/}
      {/*</article>*/}
    </section>
  );
}

export default NotFoundPage;
